module.exports = __webpack_public_path__ + "media/images/wildapricot-94f8213f76a2828541e56bf4ae76d63a.png";